module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"no-data":"Список пуст"}}')
  delete Component.options._Ctor
}
